import React, { ReactNode } from 'react'
import { scrollToSection } from '../../utils'

type Props = {
  id: string
  className: string
  current?: boolean
  children: ReactNode
}

// An in-page link that scrolls (smoothly, unless reduced motion) to a section.
export const SectionLink = ({ id, className, current = false, children }: Props) => {
  const onClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault()
    scrollToSection(id)
  }

  return (
    <a href={`#${id}`} className={className} aria-current={current ? 'location' : undefined} onClick={onClick}>
      {children}
    </a>
  )
}
